// Registrační seznamy agend modulu Products — konzumuje je centrální registr native agend
// (`app/router/nativeAgendaRegistry`) pro globální registraci v kernelu (agendy nemají vlastní route).

import type { AgendaRegistration } from '@/shared/navigation';

import { PRODUCTS_STATIONS, PRODUCTS_STATION_CHAINS } from './permissions';
import {
  stationDetailAgenda,
  StationDetailPage,
  stationListAgenda,
  StationListPage,
} from './stations';
import { stationChainListAgenda } from './stations/chains/list/stationChainListAgenda';
import { StationChainListPage } from './stations/chains/list/stationChainListPage';
import { stationChainDetailAgenda } from './stations/chains/detail/stationChainDetailAgenda';
import { StationChainDetailPage } from './stations/chains/detail/StationChainDetailPage';

/** Agendy slice Stanice (route `/products`). */
export const productsStationsAgendas: AgendaRegistration[] = [
  { agenda: stationListAgenda, component: StationListPage, permission: PRODUCTS_STATIONS },
  { agenda: stationDetailAgenda, component: StationDetailPage, permission: PRODUCTS_STATIONS },
];

/** Agendy slice Trasy autobusů (route `/products-chains`). */
export const productsChainsAgendas: AgendaRegistration[] = [
  {
    agenda: stationChainListAgenda,
    component: StationChainListPage,
    permission: PRODUCTS_STATION_CHAINS,
  },
  {
    agenda: stationChainDetailAgenda,
    component: StationChainDetailPage,
    permission: PRODUCTS_STATION_CHAINS,
  },
];
